import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const fetchUnreadCount = async () => {
  const response = await axiosInstance.get('/notifications/unread_count/');
  return response.data;
};

export const useUnreadCount = (options = {}) => {
  const { data, error, isLoading, isError, refetch, isFetching } = useQuery({
    queryKey: ['notifications', 'unreadCount'],
    queryFn: fetchUnreadCount,
    enabled: options.enabled ?? true,
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchInterval: 30 * 1000,
    refetchOnWindowFocus: true,
  });

  return {
    unread: data?.unread,
    globalUnread: data?.global,
    personalUnread: data?.personal,
    error,
    isLoading,
    isError,
    isFetching,
    refetch,
  };
};
